export default function EmptyState({ title = "Nothing here yet.", note }) {
  return (
    <div className="text-center py-16">
      <p className="text-sm font-medium text-neutral-700">{title}</p>
      {note && <p className="mt-1 text-sm text-neutral-500">{note}</p>}
    </div>
  );
}
